<template>
  <zl-dialog class="zl-saas electronic-dialog voucher-common-dialog" title="查看凭证" ref="dialog" width="1200px" :close-on-click-modal="false">
    <div class="common-btns">
      <el-button v-if="!isSign" icon="iconfont icon-dianziqianzhang" plain type="primary" @click="sign">签章</el-button>
      <el-button icon="iconfont icon-xiazai" type="primary" @click="downloadElectronicOrder">下载</el-button>
      <el-button icon="el-icon-printer" type="primary" @click="printFun">打印</el-button>
    </div>
    <div class="common-content">
      <zsPdf
        v-if="src"
        :src="src"
      />
    </div>
    <div style="display:none;">
      <pdf
        ref="pdf"
        :src="src">
      </pdf>
    </div>
  </zl-dialog>
</template>
<script>
import store from '@/store'
import zsPdf from '../zsPdf.vue'
import config from '@/config/config'
import pdf from 'vue-pdf'
export default {
  components: {
    pdf,
    zsPdf
  },
  data() {
    return {
      isSign: false, // 是否签章过
      fileId: '', // PDF的id
      src: '', // 预览PDF的url
      baseInfo: ''
    }
  },
  mounted() {
  },
  methods: {
    printFun() {
      this.$refs.pdf.print()
    },
    // 预览pdf
    async previewElectronicOrder() {
      await store.dispatch(`${this.system === 'purchaser' ? 'downloadElectronicCert' : 'downloadElectronicCertGys'}`, {
        orderId: this.orderId
      })
        .then(res => {
          this.fileId = res
        })
      const result = await this._util.getFileToken(2, 1, this.fileId)
      this.src = `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${this.fileId}&token=${result}`
    },
    // 下载文件
    downloadElectronicOrder() {
      window.open(this.src)
    },
    async open(args) {
      this.orderId = args.orderId
      this.system = args.system
      this.isSign = args.isSign
      this.baseInfo = args.baseInfo
      console.log('baseInfo', this.baseInfo)
      await this.previewElectronicOrder()
      return this.$refs.dialog.open()
    },
    // 签章
    sign() {
      this.$zl.wCA.CASign({
        pdfUrl: this.src,
        projName: '招商局',
        signatureName: '金格',
        thumbnail: true,
        unAutoClose: true, // 不自动关闭
        CADriver: '', // 没有安装数字证书时的驱动下载链接
        callback: (val, guid) => {
          // 打开签章图片
          if (val) {
            this.handleVal(val)
          }
        }
      })
    },
    // 签章后保存签章图片
    handleVal(val) {
      store.dispatch(`${this.system === 'purchaser' ? 'saveSignPdf' : 'saveSignPdfGys'}`, {
        signData: val,
        pdfGuid: this.fileId,
        pdfName: this.baseInfo?.fileList?.[0]?.name || '电子订单.pdf'
      }).then(res => {
        this.saveNewPdf(res)
      })
    },
    saveNewPdf(val) {
      store.dispatch(`${this.system === 'purchaser' ? 'saveCertPdfFileId' : 'saveCertPdfFileIdGys'}`, {
        certFileId: val,
        orderId: this.orderId
      }).then(async res => {
        this.$refs.dialog.close(true)
      })
    },
    cancel() {
      this.$refs.dialog.cancel()
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/voucher.scss';
</style>
